import * as ActionType from '../constants/constant_action_types';

const INITIAL_STATE = {
  list: [],
  pagination: {
    page: 1,
    perPage: 10,
    totalRows: 0,
  },
  data: {
    on_hand: 0,
    average_cost: 0,
    on_hand_total_cost: 0,
    floor_price: 0,
    min_reorder_point: 0,
    max_reorder_point: 0,
    back_order_quantity: 0,
    loyalty_multiplier: 1,
  },
  used_location_ids: [],
  isFetchingList: false,
  isModalActive: false,
  isModalLoading: false,
  modalHeader: '',
  viewMode: true,
  showMessageModal: false,
  isProcessing: false,
  successProcess: '',
  noOfItems: 0,
};

export function itemLocationReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionType.SET_ITEM_LOCATION: {
      let result = {
        ...state,
        data: { ...action.data },
      };

      return result;
    }

    case ActionType.CLEAR_ITEM_LOCATION: {
      const initialState = { ...INITIAL_STATE };
      delete initialState.data;
      return {
        ...state,
        ...initialState,
        list: state.list,
      };
    }

    case ActionType.OPEN_ITEM_LOCATION_MODAL: {
      return {
        ...state,
        isModalActive: true,
      };
    }

    case ActionType.CLOSE_ITEM_LOCATION_MODAL: {
      return {
        ...state,
        isModalActive: false,
      };
    }

    case ActionType.VIEW_ITEM_LOCATION_MODAL: {
      return {
        ...state,
        viewMode: true,
      };
    }

    case ActionType.EDIT_ITEM_LOCATION_MODAL: {
      return {
        ...state,
        viewMode: false,
      };
    }

    case ActionType.SHOW_APPLY_TO_ALL_STORE_MESSAGE_MODAL: {
      return {
        ...state,
        showMessageModal: action.showMessageModal,
      };
    }

    case ActionType.PROCESSING_APPLY_TO_ALL_STORE: {
      return {
        ...state,
        isProcessing: action.isProcessing,
        noOfItems: action.noOfItems,
        successProcess: action.success,
      };
    }

    case ActionType.SET_ITEM_LOCATION_LIST: {
      return {
        ...state,
        list: action.list,
        isFetchingList: false,
      };
    }

    case ActionType.GET_ITEM_LOCATION_LIST_IN_PROGRESS: {
      return {
        ...state,
        isFetchingList: true,
      };
    }

    case ActionType.SET_MODAL_LOADING: {
      return {
        ...state,
        isModalLoading: action.loading,
      };
    }

    case ActionType.SET_ITEM_LOCATIONS_PAGINATION: {
      let newState = { ...state };
      if (action.page) newState.pagination.page = action.page;
      if (action.perPage) newState.pagination.perPage = action.perPage;
      if (action.totalRows >= 0)
        newState.pagination.totalRows = action.totalRows || 0;
      return newState;
    }

    default:
      return state;
  }
}
